import PropTypes from 'prop-types';
import React from "react";
import cx from "classnames";


import isEqual from "is-equal";

import CustomFieldView from "./CustomFieldView";
import styles from "./styles.module.scss";

import { localizedStrings } from 'src/localization';

class CustomFieldSearchView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedFields: this.props.value
    }

    this._handleFieldFilterSelectionChange = this._handleFieldFilterSelectionChange.bind(this);
    this._handleRemoveFilterClicked = this._handleRemoveFilterClicked.bind(this);
    this._handleResetFilters = this._handleResetFilters.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedSearch = localizedStrings.pages.search;
  }

  componentWillReceiveProps(nextProps){
    if(!isEqual(this.props.value, nextProps.value)){
      this.setState({
        selectedFields: nextProps.value
      });
    }
  }

  _handleResetFilters() {
    this._updateSelectedFields([]);
  }

  _handleFieldFilterSelectionChange(field){
    var fields = [...this.state.selectedFields];

    var foundField = false;
    fields = fields.map((item) => {
      if(item.id == field.id){
        foundField = true;

        var selectedOptions = item.options || [];
        var found = selectedOptions.find(child => {
          return child.id == field.value.id;
        })

        if(found){
          selectedOptions = selectedOptions.filter(child => {
            return child.id != field.value.id;
          });
        }else{
          selectedOptions = [...selectedOptions, field.value];
        }

        if(selectedOptions.length == 0){
          return null;
        }

        return Object.assign({}, item, {
          ...item,
          options: selectedOptions
        });
      }

      return item;
    }).filter(item => {
      return item != null;
    });;

    if(!foundField){
      fields = [...fields, {
        id: field.id,
        index: field.index,
        options: [field.value]
      }];
    }

    this._updateSelectedFields(fields)
  }

  _handleRemoveFilterClicked(field, option) {
    var fields = [...this.state.selectedFields];

    var foundField = false;
    fields = fields.map((item) => {
      if(item.id == field.id){
        foundField = true;

        var selectedOptions = item.options || [];
        var found = selectedOptions.find(child => {
          return child.id == option.id;
        })

        if(found){
          selectedOptions = selectedOptions.filter(child => {
            return child.id != option.id;
          });
        }

        if(selectedOptions.length == 0){
          return null;
        }

        return Object.assign({}, item, {
          ...item,
          options: selectedOptions
        });
      }

      return item;
    }).filter(item => {
      return item != null;
    });

    this._updateSelectedFields(fields)
  }

  _updateSelectedFields(fields){
    this.setState({
      selectedFields: fields
    }, ()=>{
      if(this.props.onChange){
        this.props.onChange(fields);
      }
    });
  }

  render() {
    var showClearFilter = this.state.selectedFields && this.state.selectedFields.length > 0;

    return (
      <div className={styles.content}>
        <h4>{ this.localizedSearch.sliders.custom_fields.title }</h4>
        {showClearFilter && 
          [
            <div className={cx(styles.clear)} onClick={this._handleResetFilters}>{ this.localizedSearch.sliders.custom_fields.actions.clear_all }</div>,
            <div className={styles.tagSection}>{this._renderTags()}</div>
          ]
        }
        {this._renderFields()}
      </div>
    );
  }

  _renderTags() {
    var items = [];

    this.state.selectedFields.forEach(field => {
      var options = field.options.map((option, index) => {
        var uniqueKey = `${field.id}-${option.id}`;

        return (
          <div key={uniqueKey} className={cx(styles.tag)}>
            <span>{option.value}</span>
            <span
              className={styles.remove}
              onClick={this._handleRemoveFilterClicked.bind(this, field, option)}
            >
              <i className="paperflite-close"/>
            </span>
          </div>
        );
      });

      items = [...items, ...options];
    });

    return items;
  }

  _renderFields(){
    if(this.props.fields.length == 0){
      return false;
    }

    return this.props.fields.map((field, index) => {
      var selectedOptions = null;
      var selectedField = this.state.selectedFields.find(item => {
        return item.id == field.id;
      })

      if(selectedField){
        selectedOptions = selectedField.options;
      }

      return (
        <CustomFieldView 
          index={index}
          key={field.id} 
          field={field} 
          fieldIndex={index}
          value={selectedOptions}
          onChange={this._handleFieldFilterSelectionChange}
        />
      );
    });
  }

}

CustomFieldSearchView.contextTypes = {
  store: PropTypes.object.isRequired
};

export default CustomFieldSearchView;
